import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import Check from '@material-ui/icons/Check';
import RoundIndeterminateCheck from '@material-ui/icons/IndeterminateCheckBoxRounded';
import IndeterminateCheck from '@material-ui/icons/IndeterminateCheckBoxSharp';
import useStyles from './CheckboxIcon.styles';
const CheckIcon = ({ indeterminate = false, round = false, }) => {
    const classes = useStyles();
    const className = cn(classes.icon, {
        [classes.indeterminate]: indeterminate,
    });
    if (indeterminate) {
        if (round) {
            return (_jsx(RoundIndeterminateCheck, { className: className, fontSize: "inherit" }));
        }
        return _jsx(IndeterminateCheck, { className: className, fontSize: "inherit" });
    }
    return _jsx(Check, { className: className, fontSize: "inherit" });
};
export default CheckIcon;
//# sourceMappingURL=CheckboxIcon.js.map